
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/trainings",
      function () {
        return require("private-next-pages/trainings/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/trainings"])
      });
    }
  